import { pushApp, initializePushApp } from './firebasePushInit'
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'

let messaging = null
const vapid = process.env.REACT_APP_PUSH_PUBLIC_API_KEY

if (isSupported()) {
  initializePushApp()
  messaging = getMessaging(pushApp)
}

export const getMessagingToken = async (): Promise<string> => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: vapid
    })
    if (currentToken) {
      return currentToken
    } else {
      console.error('No registration token available. Request permission to generate one.')
      return ''
    }
  } catch (err) {
    console.error('An error occurred while retrieving token. ', err)
    return ''
  }
}
export const onMessageListener = (executeOnMessage: (payload: any) => void) => {
  if (messaging) {
    onMessage(messaging, async (message) => {
      try {
        const payload = JSON.parse(message.data.payload)
        executeOnMessage(payload)
      } catch (error) {
        console.error(error)
      }
    })
  }
}
